import React from 'react';
import Typography from '@mui/material/Typography';

interface ConfirmationFieldProps {
  header: string;
  value: React.ReactNode;
}

const ConfirmationField: React.FC<ConfirmationFieldProps> = ({ header, value }) => (
  <>
    <Typography variant="body1" fontWeight="bold">{header}</Typography>
    <Typography sx={{ mb: 1, mt: 1 }}>{value}</Typography>
  </>
);

export default ConfirmationField;

